
import { StyleSheet, Platform } from 'react-native'
import * as colors from '../../config/colors'
import * as v from '../../config/variables'

const styles = StyleSheet.create({
  container: {},
  iconContainer: {
    marginTop: Platform.OS === 'android' ? 4 : 0,
    width: 38,
    height: 40,
    alignItems: 'center',
    justifyContent: 'center',
  },
  spinnerContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    // borderWidth: 1
  },
  spinnerContainerArticle: {
    paddingVertical: v.SPACE_MD,
  },
  statusMessage: {
    paddingHorizontal: v.SPACE_SM,
    paddingVertical: v.SPACE_MD,
    textAlign: 'center',
    color: colors.gray,
  },
  listItemContainer: {
    marginBottom: v.SPACE_SM,
  },
  listItemInner: {
    // paddingVertical: v.SPACE_SM,
    // paddingHorizontal: v.SPACE_MD
    height: 80,
    backgroundColor: colors.white,
    padding: v.SPACE_MD,
    borderRadius: v.BORDER_RADIUS_SMALL,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  listItemIconContainer: {
    flexShrink: 0,
    // alignSelf: 'flex-end'
  },
  listItemIcon: {
    right: -10,
    color: colors.blue,
  },
  listItemTextContainer: {
    flexShrink: 1,
    // borderWidth: 1,
    // borderColor: colors.red,
    // marginVertical: v.SPACE_MD
  },
  newsDateText: {
    color: colors.blue,
    fontSize: v.FONT_SIZE_SMALL,
    marginBottom: 2,
  },
  newsTitleText: {},
  contentContainer: {
    // paddingHorizontal: 0,
    paddingVertical: 0,
    marginBottom: v.SPACE_LG,
  },
  articleTitle: {},
  newsDetailHeader: {
    paddingTop: v.SPACE_MD,
    paddingHorizontal: v.SPACE_SM,
  },
})

export default styles
